(function ($) {
    $(document).ready(function () {
        let canClickMobileMenu = true;

        function initMobileMenuDropdown() {
            const isMobile = $(window).width() <= 1080;
            const $mobileMenuItems = $('.header-mobile .navbar-nav > li.menu-item-has-children');

            $mobileMenuItems.each(function () {
                const $item = $(this);
                const $link = $item.children('a');
                const $submenu = $item.children('.sub-menu');

                if (isMobile) {
                    if (!$item.hasClass('active')) {
                        $submenu.hide();
                    }

                    $link.off('click.mobileSubmenu').on('click.mobileSubmenu', function (e) {
                        e.preventDefault();

                        if (!canClickMobileMenu) {
                            return;
                        }

                        canClickMobileMenu = false;

                        if ($item.hasClass('active')) {
                            $item.removeClass('active');
                            $link.removeClass('active');
                            $submenu.stop(true, true).slideUp();
                        } else {
                            $item.addClass('active');
                            $link.addClass('active');
                            $submenu.stop(true, true).slideDown();
                        }

                        setTimeout(function () {
                            canClickMobileMenu = true;
                        }, 500);
                    });
                } else {
                    $link.off('click.mobileSubmenu');
                    $item.removeClass('active');
                    $link.removeClass('active');
                    $submenu.removeAttr('style');
                }
            });
        }

        $('.navbar-toggle').on('click', function (e) {
            e.preventDefault();

            if ($(this).hasClass('collapsed')) {
                $('.header').addClass('mobile-activated-menu');
                $('html').addClass('overflow-hidden');
            } else {
                $('.header').removeClass('mobile-activated-menu');
                $('html').removeClass('overflow-hidden');
            }
        });

        initMobileMenuDropdown();
        $(window).on('resize', initMobileMenuDropdown);
    });
})(jQuery);